
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data() {
return {
pickerStatus:false,
loginShow:false,
popUp:false,
dateStatus:false,
index:0,
datas:{
clothe_in: 0,
clothe_out: 0,
count_in: 0,
count_out: 0,
shoe_in: 0,
shoe_out: 0,
},
account:'',
password:'',
startDate:'',
endDate:'',
store_title:'请选择',
community:[],
}
},
created(){
if(!this.$func.getLocal('factory_token')){
this.$router.push({path:'/factoryData'});
}else{
this.getCommunity();
this.setDate();
}
},
methods: {
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
var date = new Date(this.endDate);
console.log(date);

var date1 = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
},
reset(){
this.store_code = '';
this.store_title = '请选择';
this.setDate();
setTimeout(() => {
this.getData();

}, 300);
},
onChange (value) {
console.log(value);
let that = this;
this.community.forEach((item,index)=>{
if(item.key == value){
that.store_title = item.value+'('+item.warehouse_number+')';
that.store_code = item.id;
return;
}
})
},
getData() {
this.$func.startLoading();
this.$api.getInOutFactoryData({start:this.startDate,end:this.endDate,code:this.store_code}).then((res)=>{
if(res){
this.datas = res.data;
this.pickerStatus = false;
this.$func.endLoading();
}
})
},
getCommunity() {
this.$api.getInOutFactoryCommunity({}).then((res)=>{
if(res){
this.community = res.data.community;
this.store_title = this.community[0].value+'('+this.community[0].warehouse_number+')';
this.store_code = this.community[0].id;
this.getData();
}
})
},
login(){
let that = this;
if (!that.account) {
that.$func.showToast('请输入账号');
return false;
}
if (!that.password) {
that.$func.showToast('请输入密码');
return false;
}
that.$api.loginTemporary({
account: that.account,
password: that.password,
}).then((res)=>{
if(res){
that.$func.setLocal('factory_token',res.data.token);
that.popUp = false;
that.loginShow = false;
that.getFactory();
that.setDate();
setTimeout(() => {
that.getData();
}, 300);
}
});
},
out(){
this.$func.confirm('确认退出账号？','提示',()=>{
this.$func.setLocal('factory_token','');
setTimeout(()=>{
window.location.reload();
},300);
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/countInOutFactory.vue